export default __webpack_public_path__ + "static/media/profile-large.cae7c392.jpg";